import React, { memo } from "react";

import Icon from "app/components/Icon/Icon";
import { ReactComponent } from "./svgs/number_of_test_flows.svg";

export const NumberOfTestFlowsIcon = memo(() => {
  return <Icon component={ReactComponent} />;
});
